// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+EnmL","year":"styles_year__-nPg5","activeYear":"styles_activeYear__UCGN7"};